import React, { Component } from 'react';
import { Grid } from 'react-app-flexbox-grid';
import Error from './Error/Error';
import './NoMatch.css';

class NoMatch extends Component {
  render() {
    return (
      <Grid fluid className="nomatch">
        <Error message={'Sorry, page not found'}/>
      </Grid>
    )
  }
}

export default NoMatch




// WEBPACK FOOTER //
// ./src/components/NoMatch.js